// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__AVbPu","l3-0":"loader_l3-0__qfzjI","l3-1":"loader_l3-1__24lQI"};